import styled from "styled-components";
import { logout as LogOut } from "../assets/icons/Icons";
import { Link, useNavigate } from "react-router-dom";
import { cn } from "../lib/utils";
import { ConfirmDialog } from "../components/dialogs/confirm";
import { useDisclose } from "../hooks/useDisclose";
import { useCallback } from "react";
import { useAuth } from "../hooks/useAuth";

export function Nav(props: { children: React.ReactNode }) {
	return (
		<nav className="bg-sidebar-background text-sidebar-primary flex-1 flex flex-col">
			{props.children}
		</nav>
	);
}
export function NavGroup(props: { children: React.ReactNode }) {
	return <div className="grid auto-rows-fr">{props.children}</div>;
}
export function NavTitle(props: { children: React.ReactNode }) {
	return (
		<div className="h-10 mb-2 pl-(--sidebar-icons-width) uppercase mt-3">
			{props.children}
		</div>
	);
}

interface NavItemProps {
	title: string;
	description?: string;
	url: string;
	icon: any;
	// children?: NavSubItemProps[];
}
export function NavItem(props: NavItemProps) {
	const linkClass = cn(
		"flex decoration-none ",
		"transition-colors duration-100 ease-in-out",
		"hover:bg-sidebar-background-hover active:bg-sidebar-background-hover focus:bg-sidebar-background-hover aria-selected:bg-sidebar-background-hover",
	);

	return (
		<Link
			to={props.url}
			aria-selected={window.location.pathname === props.url}
			className={linkClass}
			style={{ WebkitTapHighlightColor: "transparent" }}
		>
			<div className="text-sidebar-accent w-(--sidebar-icons-width) px-5 pt-2">
				{<props.icon />}
			</div>
			<div className="w-(--sidebar-text-width) border-b-1 border-sidebar-primary pt-2 pb-2 pr-2">
				<h2 className="text-sidebar-accent font-medium">{props.title}</h2>
				<p className="leading-[125%] mt-1 ">{props.description}</p>
			</div>
		</Link>
	);
}

export function CerrarSesion() {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const linkClass = cn(
		"flex decoration-none py-5",
		"hover:bg-sidebar-background-hover active:bg-sidebar-background-hover focus:bg-sidebar-background-hover",
		"hover:text-sidebar-accent",
	);

	const dialog = useDisclose();

	const onClose = dialog.onClose;
	const cerrarSesion = useCallback(() => {
		onClose();
		logout();
		navigate("/login");
	}, [onClose, logout, navigate]);

	return (
		<>
			<button
				onClick={dialog.onOpen}
				className={linkClass}
				style={{ WebkitTapHighlightColor: "transparent" }}
			>
				<div className="text-sidebar-accent w-(--sidebar-icons-width) px-5">
					{<LogOut />}
				</div>
				<div className="w-(--sidebar-text-width) border-sidebar-primary">
					<h2 className="text-sidebar-accent">Cerrar sesión</h2>
				</div>
			</button>

			<ConfirmDialog
				open={dialog.isOpen}
				title="Cerrar sesión"
				description="¿Estás seguro de que quieres cerrar sesión?"
				onConfirm={cerrarSesion}
				onCancel={dialog.onClose}
			/>
		</>
	);
}

export const Spacer = styled.div`
	flex: 1;
`;
